export default function findFocusedHex(items: any) {
  if (!document.activeElement?.id) return false;
  if (!document.activeElement.classList.contains('dropzone-btn')) return false;
  // @ts-ignore
  return items.find((h) => h.id === document.activeElement.value);
}
